import React from 'react';
import Calendar from '../components/ui/Calendar';

const HERO_IMAGE = "https://cdn.midjourney.com/1735d2cb-dd85-448b-8a40-9d9358f94b60/0_1.webp";

export default function CalendarPage() {
  return (
    <div className="h-full w-full space-y-6">
      {/* Hero Header */}
      <div className="relative h-48 lg:h-64 rounded-3xl overflow-hidden shadow-xl">
        <div className="absolute inset-0 bg-black/30 z-10" />
        <img 
          src={HERO_IMAGE} 
          alt="Calendar" 
          className="w-full h-full object-cover" 
        />
        <div className="absolute inset-0 z-20 flex flex-col justify-end p-6 lg:p-8">
          <h1 className="text-3xl lg:text-4xl font-cormorant font-bold text-white mb-2 text-shadow-sm">
            Calendar
          </h1>
          <p className="text-white/90 font-dm-sans max-w-lg">
            Visualize your seasons. Plan your days and weeks to ensure a steady rhythm of growth.
          </p>
        </div>
      </div>

      <Calendar />
    </div>
  );
}